<template>
    <v-container grid-list-md>
            <div id="printMe" class="marca">
                <div v-for="(data, i) in facturas" :key="i">
                    <table style="width:100%;">
                        <thead>
                            <tr>
                                <th align="left">CPC: {{ data.unionize.cpc }} Nombre: {{ data.unionize.user.name }}</th>
                                <th align="right">Factura Numero: {{ data.id }}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th align="left">Rif y/o Cedula: {{ data.unionize.user.nacionality }}{{ data.unionize.user.number_id }}</th>
                                <th align="right">Fecha de Emisión: {{ data.payment_date }}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th align="left"></th>
                                <th align="right">Cond. de pago: </th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th align="left"></th>
                                <th align="right">Cajero: {{ data.cash_assignment != null ? data.cash_assignment.cash.name : 'Caja Web' }}</th>
                            </tr>
                        </thead>
                    </table>
                    <table style="width:100%;">
                        <thead>
                            <tr>
                                <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CODIGO</th>
                                <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">DESCRIPCION</th>
                                <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CANTIDAD</th>
                                <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">COSTO UNIT.</th>
                                <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">TOTAL Bs.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="concepts in data.service_payments" :key="concepts.id">
                                <td align="left">{{ concepts.concept_cost.concept.code }}</td>
                                <td align="left">{{ concepts.concept_cost.concept.name }}</td>

                                <td align="left" v-if="concepts.concept_cost.concept.code != 'HSEG' && concepts.concept_cost.concept.code != 'HSEGUEL'">{{ concepts.concept_cost.concept.qty }}</td>
                                <td align="left" v-if="concepts.concept_cost.concept.code == 'HSEG'">{{ data.solicitud_papeles.cantidad }}</td>
                                <td align="left" v-if="concepts.concept_cost.concept.code == 'HSEGUEL'">{{ concepts.count }}</td>

                                <td align="right" v-if="concepts.concept_cost.concept.code == 'RAP'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.ruap.concept_document_type.amount).toFixed(2)) }}</td>
                                <td align="right" v-if="concepts.concept_cost.concept.code == 'NCRED'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.amount).toFixed(2)) }}</td>
                                <td align="right" v-if="concepts.concept_cost.concept.code != 'NCRED' && concepts.concept_cost.concept.code != 'RAP'">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.concept_cost.amount).toFixed(2)) }}</td>
                                
                                <td v-if="concepts.concept_cost.concept.code == 'NCRED'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.amount).toFixed(2)) }}</td>
                                <td v-if="concepts.concept_cost.concept.code == 'HSEG'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat((concepts.concept_cost.amount * data.solicitud_papeles.cantidad)).toFixed(2)) }}</td>
                                <td v-if="concepts.concept_cost.concept.code == 'HSEGUEL'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat((concepts.amount * concepts.count)).toFixed(2)) }}</td>
                                <td v-if="concepts.concept_cost.concept.code == 'RAP'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.ruap.concept_document_type.amount).toFixed(2)) }}</td>
                                <td v-if="concepts.concept_cost.concept.code != 'HSEGUEL' && concepts.concept_cost.concept.code != 'NCRED' && concepts.concept_cost.concept.code != 'HSEG' && concepts.concept_cost.concept.code != 'RAP'" align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(concepts.concept_cost.amount).toFixed(2)) }}</td>
                            </tr>
                            <tr v-if="getRuapAmount(data) != 0">
                                <td align="left">GG</td>
                                <td align="left">CUOTA POR GESTIÓN GREMIAL</td>
                                <td align="left">1</td>
                                <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(getRuapAmount(data)).toFixed(2)) }}</td>
                                <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(getRuapAmount(data)).toFixed(2)) }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="3" style="border-top: 3px dashed;">FORMA DE PAGO: {{ data.payments.length != 0 ? data.payments[0].way_to_pay : '' }} </td>
                                <td align="right" style="border-top: 3px dashed;">SUB-TOTAL :</td>
                                <td align="right" style="border-top: 3px dashed;">{{ new Intl.NumberFormat("de-DE").format(parseFloat(supTotal(data)).toFixed(2)) }}</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <!-- <td align="right">--.-- % IVA :</td> -->
                                <!-- <td align="right">{{ txAmount }} % IVA :</td> -->
                                <td align="right">{{ getIva(data).txAmount }} % IVA :</td>
                                <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(getIva(data).monto_iva).toFixed(2)) }}</td>
                            </tr>
                            <tr>
                                <td colspan="3">SOLO PARA EL USO DEL CONTADOR PUBLICO</td>
                                <td align="right">TOTAL :</td>
                                <td align="right">{{ new Intl.NumberFormat("de-DE").format(parseFloat(data.amount).toFixed(2)) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="page-break"></div>
                </div>
            </div>
    </v-container>
</template>

<script>
export default {

    props: {
        facturas: {
            type: Array,
            required: true
        }
    },

    data () {
        return {
            datos: [],
            txAmount: 0,
            total: 0,
            ruap_amount: 0,
            sup_total: 0,
            sumatoria_sub_total: 0,
            monto_iva: 0,
            monto_gg: 0,
        }
    },

    mounted() {
        this.datos = this.facturas
    },

    methods: {

        getIva(datos) {
            let sumatoria_iva = 0;
            let total = 0;
            let monto_gg = 0;
            let monto_iva = 0;
            let txAmount = 0;
            datos.service_payments.forEach(sp => {
                    if(sp.concept_cost.concept_taxes.length != 0){
                        sp.concept_cost.concept_taxes.forEach(tx => {
                            if (sp.concept_cost.concept.code == 'RAP') {
                                if (tx.tax.code == 'IVA') {
                                    txAmount = parseInt(tx.tax.amount)
                                    let monto = parseFloat(sp.ruap.concept_document_type.amount)
                                    let montogg = parseFloat(sp.ruap.concept_document_type.gg_amount)
                                    // let sum_montos = monto + montogg
                                    let sum_montos = monto
                                    monto_iva = (txAmount / 100) * sum_montos
                                    sumatoria_iva = sumatoria_iva + monto_iva
                                    total = parseFloat(sum_montos + monto_iva) + montogg
                                }
                            }else {
                                if (tx.tax.code == 'IVA') {
                                    let txAmount = parseInt(tx.tax.amount)
                                    let cantidad_items = 0
                                    if(sp.concept_cost.concept.code == 'HSEG'){
                                        cantidad_items = datos.solicitud_papeles.cantidad
                                    }else {
                                        cantidad_items = sp.concept_cost.concept.qty
                                    }
                                    let cantidad = parseFloat(parseFloat(sp.concept_cost.amount) * cantidad_items)
                                    monto_iva = (txAmount / 100) * cantidad
                                    sumatoria_iva = sumatoria_iva + monto_iva
                                    total = parseFloat(cantidad + monto_iva)
                                }
                            }
                        })
                    }
            });
            monto_iva = sumatoria_iva;

            return {
                txAmount,
                sumatoria_iva,
                total,
                monto_gg,
                monto_iva
            };
        },

        getRuapAmount(data) {
            let monto_gg = 0;
            data.service_payments.forEach(sp => {
                if (sp.concept_cost.concept.code == 'RAP') {
                    monto_gg = parseFloat(sp.ruap.concept_document_type.gg_amount)
                }
            });

            return monto_gg;
        },

        supTotal(data) {
            let sumatoria_sub_total = 0;
            let sup_total = 0;
            data.service_payments.forEach(sp => {
                if (sp.concept_cost.concept.code == 'RAP') {
                    let monto = parseFloat(sp.ruap.concept_document_type.amount)
                    let montogg = parseFloat(sp.ruap.concept_document_type.gg_amount)
                    sumatoria_sub_total = parseFloat(sumatoria_sub_total) + (monto + montogg)
                }else if (sp.concept_cost.concept.code == 'HSEG') {
                    sumatoria_sub_total = parseFloat(sumatoria_sub_total) + (parseFloat(sp.concept_cost.amount) * parseInt(data.solicitud_papeles.cantidad))
                }else if (sp.concept_cost.concept.code == 'HSEGUEL') {
                    sumatoria_sub_total = parseFloat(sumatoria_sub_total) + (parseFloat(sp.amount) * parseInt(sp.count))
                }else {
                    sumatoria_sub_total = parseFloat(sumatoria_sub_total) + parseFloat(sp.concept_cost.amount)
                }
            });
            sup_total = sumatoria_sub_total;
            return sup_total;
        }

    }

}
</script>
<style scoped>

@media print {

    html, body {
        display: block; 
        font-family: "Calibri";
        /* font-family: Arial, sans-serif; */
        /* writing-mode: tb-rl; */
    }

    @page {
        padding: 0;
        margin: 40mm 10mm 0 10mm;
        size: 210mm 279mm portrait;
    }

    @page rotated { size: 210mm 279mm portrait; }

    .page-break {
        page-break-after: always;
    }
}

@media screen {
    
    .marca:after {
        content: url('/img/newlogo.png');
        font-size: 15em;
        opacity: 0.1;
        z-index: 1;

        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 120px;
        right: 0;
        bottom: 0;
        left: 0;

        -webkit-pointer-events: none;
        -moz-pointer-events: none;
        -ms-pointer-events: none;
        -o-pointer-events: none;
        pointer-events: none;

        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
}



</style>




// WEBPACK FOOTER //
// resources/assets/js/components/factura/PrintArrayFacturas.vue